import { Box, Menu as MuiMenu } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const TemplateOptionsMenuContainer = styled(Box)`
  .menu-icon-button {
    display: flex;
    width: 48px;
    height: 48px;
    padding: ${theme.spacing.xSmall}px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: ${theme.attributes.borderRadius.tertiary};
    border: 1px solid ${theme.colors.dropdownBorder};

    svg {
      stroke: ${theme.colors.menuItemText};
    }

    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }
`

export const StyledMenu = styled(MuiMenu)`
  .MuiPaper-root {
    width: 200px;
    border-radius: ${theme.attributes.borderRadius.secondary};
    background: ${theme.colors.labelCardBg};
    box-shadow: ${theme.attributes.boxShadow.secondary};

    html[data-theme='light'] & {
      box-shadow: ${theme.colors.tooltipShadow};
      border: 1px solid ${theme.colors.strokePrimary};
    }

    .MuiList-root {
      padding-top: 0;
      padding-bottom: 0;

      .MuiDivider-root {
        border-color: ${theme.colors.dropdownBorder};
      }

      .MuiMenuItem-root {
        height: auto;
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xSmall}px;
        padding-top: 10px;
        padding-bottom: 10px;

        &:not(.destructive) svg {
          stroke: ${theme.colors.devicesSecondaryText};
        }

        .MuiTypography-root {
          color: ${theme.colors.menuItemText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 22px;
        }

        &:first-of-type {
          padding-top: 16px;
        }

        &:last-of-type {
          padding-bottom: 16px;
        }

        &:hover {
          background: ${theme.colors.menuItemHover};
        }

        &.Mui-selected,
        &.Mui-focusVisible {
          html[data-theme='light'] & {
            background: ${theme.colors.cardFillTertiary};
          }
        }

        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }

        &.destructive {
          .MuiTypography-root {
            color: #E74C3C;
          }
        }
      }
    }
  }
`
